import { useKeycloak } from "../src/useKeycloak";

/**
 * useUserRole
 * @returns {{role: string, hasElevatedRights: boolean}}
 */
const useUserRole = () => {
	const { tokenParsed } = useKeycloak();

	let role = "operator";
	if (tokenParsed?.resource_access?.youtello?.roles?.includes("superadmin")) {
		role = "superadmin";
	}
	else if (tokenParsed?.resource_access?.youtello?.roles?.includes("orgadmin")) {
		role = "orgadmin";
	}

	const hasElevatedRights = role === "superadmin" || role === "orgadmin";

	const allRoles = tokenParsed?.resource_access?.youtello?.roles;

	return { role, hasElevatedRights, allRoles };
};

export default useUserRole;
